import axios from "axios";

export function getTeam(s: string = '', club_id: string = '', modality_id: string = '', category_id: string = '', sortby: string = 'latest') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/team';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (club_id.length > 0) {
        params.push('club_id=' + club_id);
    }
    if (modality_id.length > 0) {
        params.push('modality_id=' + modality_id);
    }
    if (category_id.length > 0) {
        params.push('category_id=' + category_id);
    }
    if (sortby.length > 0) {
        params.push('sortby=' + sortby);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getTeamSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/team/' + id;
    return axios.get(endpointUrl, { headers: headers } );
}

export function getTeamOptions(season = 0, club = 0) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const param_array = [];
    if (season != 0) {
        param_array.push('season=' + season);
    }
    if (club != 0) {
        param_array.push('club=' + club);
    }
    let params = '';
    if (param_array.length > 0) {
        params = '?' + param_array.join('&');
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/team/options' + params;
    return axios.get(endpointUrl, { headers: headers } );
}

export function createTeam(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/team';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateTeam(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/team';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteTeam(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/team/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}